import axios from "axios";

const api = axios.create({
  baseURL: "http://localhost:8087",
  headers: {
    "Content-Type": "application/json",
  },
});

/*
GET SAVED SHORTS WITH PAGINATION
*/
const getSavedShorts = (queryParams) => {
  const token = localStorage.getItem("token");

  return api.get(`/api/getsavedshorts?${queryParams}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

const getDownloadShorts = async (videoURL, showToast) => {
  const token = localStorage.getItem("token");

  try {
    // 🔥 Start toast
    showToast("Downloading clip...", "loading");

    const res = await api.get(
      `/api/download?url=${encodeURIComponent(videoURL)}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      },
    );

    // -------------------------------
    // EXTRACT FILENAME
    // -------------------------------
    let fileName = "clip.mp4";

    const contentDisposition = res.headers["content-disposition"];
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="(.+)"/);
      if (match) fileName = match[1];
    }

    // -------------------------------
    // DOWNLOAD
    // -------------------------------
    const blob = new Blob([res.data]);
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;

    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);

    // ✅ Success toast
    showToast("Download complete 🎬", "success");
  } catch (err) {
    console.error(err);

    // ❌ Error toast
    showToast("Download failed ❌", "error");
  }
};

/*
UPDATE SHORT TITLE
*/
const updateShort = (shortId, title) => {
  const token = localStorage.getItem("token");

  return api.put(
    `/updateshort/${shortId}`,
    { title },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export { getSavedShorts, updateShort, getDownloadShorts };
